import { render, staticRenderFns } from "./HaulageDashboardPageV2.vue?vue&type=template&id=ff8c03fe&scoped=true&"
import script from "./HaulageDashboardPageV2.vue?vue&type=script&lang=js&"
export * from "./HaulageDashboardPageV2.vue?vue&type=script&lang=js&"
import style0 from "./HaulageDashboardPageV2.vue?vue&type=style&index=0&id=ff8c03fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8c03fe",
  null
  
)

export default component.exports